<template>

    <div>

        <el-dialog
                :title="title"
                :visible.sync="dialogFormVisible"
                width="95%"
                @close="close"
        >

            <div class="title" style="margin-bottom: 20px">
                <div>优秀项目经理推荐汇总表</div>
            </div>

            <div style="text-align: right">
                <el-button style="margin-bottom: 10px" @click="exportExcel">导出</el-button>
            </div>
            <div style="text-align: left">
                推荐单位：{{recommend_unit_name}}
            </div>
            <div style="width: 100%">
                <table class="gridtable">

                    <tbody>
                    <tr>

                        <td rowspan="3">序号</td>
                        <td colspan="6">基本情况</td>
                        <td colspan="8">保证项目</td>
                        <td colspan="3">评价项目</td>
                    </tr>

                    <tr>
                        <td rowspan="2">推荐单位</td>
                        <td rowspan="2">所在单位</td>
                        <td rowspan="2">姓名</td>
                        <td rowspan="2">性别</td>
                        <td rowspan="2">身份证号码</td>
                        <td rowspan="2">联系人电话</td>
                        <td rowspan="2">职称</td>
                        <td rowspan="2">年龄</td>
                        <td rowspan="2">工作年限</td>
                        <td rowspan="2">建造师主项专业及等级</td>
                        <td rowspan="2">注册证书编号</td>
                        <td rowspan="2">近三年继续教育学时</td>
                        <td rowspan="2">安全证明</td>
                        <td rowspan="2">申报资料内容及盖章签字（是否齐全）</td>
                        <td colspan="2">获奖情况</td>
                        <td rowspan="2">理论造诣</td>
                    </tr>

                    <tr>
                        <td>科技成果</td>
                        <td>工程奖</td>
                    </tr>

                    <tr v-for="(v,index) in tableData" >
                        <td>{{index+1}}</td>
                        <td>{{v.recommend_unit}}</td>
                        <td>{{v.company_name}}</td>
                        <td>{{v.name}}</td>
                        <td>{{v.sex}}</td>
                        <td>{{v.id_card}}</td>
                        <td>{{v.enp_contacts_phone}}</td>
                        <td>{{v.title}}</td>
                        <td>{{v.age}}</td>
                        <td>{{v.work_time}}</td>
                        <td>{{v.level}}</td>
                        <td>{{v.req_number}}</td>
                        <td>{{v.study_hour}}</td>
                        <td>{{v.have_safe}}</td>
                        <td >{{v.app_res}}</td>
                        <td style="text-align: left">{{v.keji}}</td>
                        <td style="text-align: left">{{v.gc_jiang}}</td>
                        <td style="text-align: left">{{v.lilun}}</td>
                    </tr>

                    </tbody>

                </table>
            </div>

        </el-dialog>

    </div>
</template>

<script>


    import {getPmHzData} from '../../../api/moudles/application.js'
    import _ from "lodash";

    import { saveAs } from "file-saver";
    import XLSX from "xlsx";
    import { export_json_to_excel } from "@/assets/js/Export2Excel";

    export default {
        name: "pm_hz_table",

        data() {
            return {
                title: '',
                formLabelWidth:'140px',
                dialogFormVisible: false,
                tableData: [],
                excelData: [], //表格数据,这个是你自己请求的真实数据

                checkList: [],
                recommend_unit_name:'',
                field :[
                    'sort',
                    'recommend_unit',
                    'company_name',
                    'name',
                    'sex',
                    'id_card',
                    'enp_contacts_phone',
                    'title',
                    'age',
                    'work_time',
                    'level',
                    'req_number',
                    'study_hour',
                    'have_safe',
                    'app_res',
                    'keji',
                    'gc_jiang',
                    'lilun',
                ],
                columns: [],
                form:{},
                selectRows: '',
                dialogVisible: false,
                projectCode: '',
            }
        },

        computed: {
            finallyColumns() {
                let finallyArray = []
                this.checkList.forEach((checkItem) => {
                    finallyArray.push(
                        this.columns.filter((item) => item.label === checkItem)[0]
                    )
                })
                return _.sortBy(finallyArray, (item) => item.order)
            },
        },

        methods: {

            //重置EXcel数据
           /* showEdit(row) {
                this.title = '导出汇总表';
                this.form = Object.assign({}, row);

                console.log(this.form)

                this.dialogFormVisible = true

                this.fetchData(this.form)
            },*/

            async fetchData(key){

                const params = {
                    project_code: key
                }
                this.loading = true
                let that = this
                await getPmHzData({
                    data: params,
                    success: (res) => {
                        this.loading = false

                        this.tableData = res.data
                        this.tableData.forEach(function(item, index) {
                            console.log(item)
                            that.recommend_unit_name = item.recommend_unit
                        })
                    }
                })

            },
            showPay(key) {
                console.log(key)
                console.log(456546546546656546)
                this.dialogFormVisible = true
                this.projectCode = key
                this.fetchData(key)
            },
            close(){
                this.dialogFormVisible = false
            },

            formatJson(filterVal, jsonData) {

                return jsonData.map((v) => filterVal.map((j) => v[j]))

            },

            //导出方法
            exportExcel() {

                const multiHeader = [
                    [
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "优秀项目经理推荐汇总表",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ],
                    [
                        "序号",
                        "推荐单位",
                        "所在单位",
                        "姓名",
                        "性别",
                        "身份证号码",
                        "联系人电话",
                        "职称",
                        "年龄",
                        "工作年限",
                        "建造师主项专业及等级",
                        "注册证书编号",
                        "近三年继续教育学时",
                        "安全证明",
                        "申报资料内容及盖章签字（是否齐全）",
                        "科技成果",
                        "工程奖",
                        "理论造诣",
                    ],

                ]; //一级表头
                const tHeader = this.checkList ;
                const filterVal = this.field
                // const data = this.excelData.map(v => filterVal.map(j => v[j]));//这一行和下面得六行代码是一样得作用的

                const list = this.tableData
                console.log(909090909);
                console.log(list);

                const data = this.formatJson(filterVal, list);//格式化
                console.log(data);
                //这个得说明一下：网上得博客每个不一样，你那我的直接用也是没啥用得，你的理解这个合并是怎么写的：根据你的多级表头，如果没有合并得从上往下写，遇到开始合并单元格的，从左往右得单行写，从上到下，直到写完整
                const merges = [


                    /*"B1:C1",
                    "C1:D1",
                    "D1:E1",
                    "E1:F1",
                    "F1:G1",
                    "H1:I1",
                    "I1:J1",
                    "J1:K1",
                    "L1:M1",
                    "M1:N1",
                    "N1:O1",
                    "O1:P1",
                    "P1:Q1",
                    "Q1:R1",*/

                ];
                export_json_to_excel({
                    multiHeader, //这里是第一行的表头
                    header: tHeader, //这里应该是算第二行的表头
                    data,//数据
                    merges,//合并行
                    filename: "优秀项目经理推荐汇总表",
                    autoWidth: true,
                    bookType: 'xlsx'
                });
            }


        }
    }
</script>

<style scoped>

    .title{
        display: flex;
        justify-content: center;
        margin-top: 50px;
    }
    /* gridtable */
    table.gridtable {
        font-family: verdana,arial,sans-serif;
        font-size:18px;
        color:#333333;
        border-width: 1px;
        border-color: #666666;
        border-collapse: collapse;
    }
    table.gridtable th {
        border-width: 1px;
        padding: 2px;
        border-style: solid;
        border-color: #666666;
        background-color: #dedede;
    }
    table.gridtable td {
        border-width: 1px;
        padding: 2px;
        text-align: center;
        border-style: solid;
        border-color: #666666;
        background-color: #ffffff;
    }
</style>
